// =============================================================================
//  Copyright : 2023 semantics GmbH
//  Date      : $Date: 2023-09-08 14:12:56 +0200 (Fri, 08 Sep 2023) $
//  Author    : Dirk Rothe
//  Worker    : $Author: o.powroznik $
//  Revision  : $Rev: 136775 $
//  Purpose   : tagclouds (legacy /nav/index/cloud)
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {sorted} from 'ldash'
import {useState, useDelay, useApi, useInView} from 'uix/hooks'

// ---Local imports
import {Link} from './links'

// ---Exports
const FONTSIZE = {1: 80, 2: 90, 3: 100, 4: 115, 5: 150}
const buildLink = ({type, caption, name, toLegacy}) => {
  // /nav/cloud/name?query=Blaas%2C%20Leo
  if (toLegacy) {
    return (
      <Link classname="nav" tabname="cloud" id={type} query={{query: name}} external target="cloud">
        {caption || name}
      </Link>
    )
  } else {
    return <Link>{name}</Link>
  }
}
export const TagCloud = ({type = 'name', hoverEffect = false, className, toLegacy = false}) => {
  let [ref, inView] = useInView({triggerOnce: true})
  let {data} = useApi('filter/getTagCloud', {id: type}, {condition: inView})
  let terms = data?.terms || []

  terms = sorted(terms, ({name}) => name).map(({name, caption, count, size}) => (
    <span
      className={className}
      key={name}
      title={`Einträge im Index: ${count}`}
      style={{display: 'inline-block', fontSize: `${FONTSIZE[size] ?? 100}%`}}
    >
      {buildLink({type, caption, name, toLegacy})}{' '}
    </span>
  ))
  return <div ref={ref}>{terms}</div>
}
